<template>
    <div>
      <div class="vx-row">
          <div class="vx-col md:w-1/5 form-group w-full">
              <vx-card>
                  <div class="con-ul-tabs">
                      <ul class="ul-tabs vs-tabs--ul ul-tabs-left">
                          <li class="vs-tabs--li activeChild" v-bind:class="[ page == 'all_vehicle' ?'default-active':'']">
                            <button type="button" class="vs-tabs--btn text-left" @click="page = 'all_vehicle' ">
                              <span>All Vehicles</span>
                            </button>
                          </li>
                          <li class="vs-tabs--li activeChild" v-bind:class="[page== 'book_vehicle' ?'default-active':'']">
                            <button type="button" class="vs-tabs--btn text-left" @click="page = 'book_vehicle' ">
                              <span>Booked Vehicles</span>
                            </button>
                          </li>
                          <li class="vs-tabs--li activeChild" v-bind:class="[page== 'vehicle_timesheet'?'default-active':'']">
                            <button type="button" class="vs-tabs--btn text-left" @click="page = 'vehicle_timesheet'">
                              <span>Vehicle Timesheets</span>
                            </button>
                          </li>
                          <li class="vs-tabs--li activeChild" v-bind:class="[page == 'view_faults' ?'default-active':'']">
                            <button type="button" class="vs-tabs--btn text-left" @click="page = 'view_faults' ">
                              <span>View Faults</span>
                            </button>
                          </li>
                      </ul>
                      <span class="line-vs-tabs" style="left: 0px; width: 2px; height: 51px; transform: scaleX(1); top: 0px;"></span>
                  </div>
              </vx-card>
          </div>
          <div class="vx-col md:w-4/5 form-group w-full">
              <allvehicle v-if="page == 'all_vehicle'"></allvehicle>
              <div class="vx-col w-full mb-base m-auto" v-if="page == 'book_vehicle'">
                <vx-card :title="'Booked Vehicles'">
                  <booked-vehicle ></booked-vehicle>
                </vx-card>
              </div>
              <timesheet v-if="page == 'vehicle_timesheet'"></timesheet>
              <viewfault v-if="page == 'view_faults'"></viewfault>
          </div>
      </div>
    </div>
</template>

<script>
import allvehicle from "./vehicles/allvehicles";
// import bookedvehicle from "./vehicles/bookedvehicle";
import BookedVehicle from "@/components/vehicle/book-vehicle.vue";
import Timesheet from "@/components/vehicle/timesheet.vue";
import viewfault from "./vehicles/faultlist";


export default {
    components: {
        allvehicle,
        BookedVehicle,
        viewfault,
        Timesheet
    },
    data() {
        return {
            page: 'all_vehicle',
        };
    },
    watch: {

    },
    created() {},
    mounted() {
        if (this.$route.query.tab == 'book-vehicle') {
            this.page = "book_vehicle";
        }
        // book-vehicle
    },
    methods: {}
};
</script>
<style>
.line-vs-tabs {
    position: absolute;
}
</style>